import KeywordSearchbar from './KeywordSearchbar.vue';

export default KeywordSearchbar;
